import { gql } from "@apollo/client";

export const GET_ALL_STATES = gql`
  {
    getAllStates {
      state_id
      state_shortname
      state_name
      created_on
      created_by
      district {
        district_id
        district
        state_id
        created_on
        created_by
      }
    }
  }
`;

export const GET_ESCALATION_MATRIX = gql`
  {
    getEscalationMatrix(level: "L1") {
      esc_id
      department
      state
      district
      complaint_type
      esc_level
      escalation
      dealer_code
      mobile_no
      f_id
      mail_id
      role_id
      created_on
      modified_on
      created_by
      modified_by
      is_dealer
      isactive
    }
  }
`;
